import { Col, Row, Space, Table } from "antd";
import { DashboardPurchaseHistoryInterface } from "../Interfaces/DashboardPurchaseHistoryInterface";
import Header from "./header";
import { SearchType } from "../Interfaces/SearchInterfaces";
import type { ColumnsType } from "antd/es/table";
// import { Search } from "../../Filter/Search";
import { useTranslation } from "react-i18next";
import ViewButton from "../UI/ViewButton/viewbutton";

type PropsType = {
  picker: string;
  tableKey: number;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
};

const DashboardPurchaseHistoryList = ({
  picker,
  tableKey,
  searchText,
  setSearchText,
}: PropsType) => {
  const { t } = useTranslation("common");

  const columns: {}[] = [
    {
      title: `${t("invoice-number")}`,
      dataIndex: "number",
      key: "number",
      width: "14%",
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      align: "center" as "center",
      width: "14%",
    },
    {
      title: `${t("item")}`,
      dataIndex: "item",
      key: "item",
      align: "center" as "center",
      width: "14%",
    },

    {
      title: `${t("quantity")}`,
      dataIndex: "quantity",
      key: "quantity",
      align: "center" as "center",
      width: "14%",
    },
    {
      title: `${t("price")}`,
      dataIndex: "price",
      key: "price",
      align: "center" as "center",
      width: "14%",
    },
    {
      title: `${t("total")}`,
      dataIndex: "total",
      key: "total",
      align: "center" as "center",
      width: "14%",
    },
    {
      title: `${t("action")}`,
      key: "action",
      align: "center" as "center",
      render: (record: any) => (
        <Space size="middle">
          <ViewButton onClick={() => console.log("hh")} />
        </Space>
      ),
    },
  ];

  const dataSource: DashboardPurchaseHistoryInterface[] = [
    {
      key: "1",
      number: "#123546",
      item: "item123",
      date: "YYYY/MM/DD",
      price: "23.00",
      quantity: 99,
      total: "111.00",
    },
    {
      key: "2",
      number: "#987654",
      item: "item184",
      date: "YYYY/MM/DD",
      price: "65.00",
      quantity: 59,
      total: "281.00",
    },
  ];
  const searchKeys = ["number", "item"];

  // var searchColumns: ColumnsType<SearchType> = Search(
  //   columns,
  //   searchKeys,
  //   searchText,
  //   setSearchText
  // );

  // searchColumns =searchColumns

  return (
    <Row>
      <Col offset={1} span={22}>
        <Header picker={picker} hasItems={true} placeholder="Supplier" />
        <Table
          scroll={{ x: 1000 }}
          dataSource={dataSource}
          columns={columns}
          rowClassName={(record, index) =>
            index % 2 === 0
              ? "table-row-light table-row"
              : "table-row-dark table-row"
          }
          style={{ marginTop: "15px" }}
        />
      </Col>
    </Row>
  );
};

export default DashboardPurchaseHistoryList;
